import { Box, Drawer, Typography, IconButton } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import Input from 'components/Common/Input';
import { useForm } from 'react-hook-form';
import Button from 'components/Common/Button';
import { useNavigate, useParams } from 'react-router-dom';
import QaChunkFormSkeleton from './QaChunkFormSkeleton';
import { useCreateOrUpdateQaChunk, useGetQaChunk } from 'apis/business/agent/qaChunks/hook';

export default function QaChunkForm() {
  const navigate = useNavigate();
  const { chunkId } = useParams();

  const { mutateAsync: handleQaChunk, isPending } = useCreateOrUpdateQaChunk();
  const { data: chunk, isLoading } = useGetQaChunk();

  const { handleSubmit, control } = useForm({
    values: {
      chunk: { question: chunk?.question, answer: chunk?.answer }
    }
  });

  const onSubmit = async (data: any) => {
    await handleQaChunk(data);
  };

  if (isLoading) {
    return <QaChunkFormSkeleton />;
  }

  return (
    <Drawer
      anchor='right'
      open={true}
      onClose={() => navigate(-1)}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 400, md: 600 },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 100001
        }
      }}
    >
      {/* Fixed Header */}
      <Box
        sx={{
          px: 3,
          py: 2,
          borderBottom: '1px solid #DEDEDE',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0
        }}
      >
        <Typography variant='h6'>{chunkId ? 'Edit' : 'Add'} Question & Answer</Typography>
        <IconButton onClick={() => navigate(-1)} size='small'>
          <IoClose size={24} />
        </IconButton>
      </Box>

      {/* Form with Fixed Footer */}
      <Box
        component='form'
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Scrollable Content */}
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            p: 3
          }}
        >
          <Input name='chunk.question' label='Question' control={control} fullWidth required />
          <Box mt={2}>
            <Input name='chunk.answer' label='Answer' control={control} minRows={6} multiline fullWidth required />
          </Box>
        </Box>

        {/* Fixed Footer */}
        <Box
          sx={{
            px: 3,
            py: 2,
            borderTop: '1px solid #DEDEDE',
            display: 'flex',
            justifyContent: 'end',
            gap: 2,
            flexShrink: 0
          }}
        >
          <Button
            color='secondary'
            variant='outlined'
            sx={{ border: '1px solid #F3F3F3' }}
            onClick={() => navigate(-1)}
          >
            Cancel
          </Button>
          <Button type='submit' variant='contained' isPending={isPending}>
            {chunkId ? 'Update' : 'Create'}
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}
